import React, { useEffect, useState } from "react";
import NavBar from "../../Component/NavBar/NavBar";
import { MdOutlineBlock, MdOutlineVerifiedUser } from "react-icons/md";
import { IoIosAddCircleOutline } from "react-icons/io";
import apiRequests from "../../Component/axios/config/config";
import Loading from "../../Component/Loading/Loading";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { BiSolidUserDetail } from "react-icons/bi";
import Pagination from "../../Component/pagination/Pagination";

export default function Users() {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [checkStatus, setCheckStatus] = useState("All User");

  const [UserBlock, setUserBlock] = useState("");

  // const [showModalEdit, setShowModalEdit] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [search, setSearch] = useState("");

  const [showModalDelete, setShowModalDelete] = useState(false);
  const [name, setName] = useState(false);
  const [UserId, setUserId] = useState("");
  const [statusUsers, setStatusUsers] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  function apiGetUser(pageNumber = page, search) {
    setLoading(true);

    apiRequests
      .get("/api/user/v1/get-usersList-by-admin", {
        params: {
          isDeleted: UserBlock,
          page: pageNumber,
          limit: 20,
          search,
        },
      })
      .then((response) => {
        setUsers(response.data.data.docs);
        setTotalPages(response.data.data.totalPages || 1);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    apiGetUser(page);
  }, [page, UserBlock]);

  function handleSearch(value) {
    setSearch(value);
    setPage(1);
    apiGetUser(1, value);
  }

  function goToPage(newPage) {
    if (newPage < 1 || newPage > totalPages) return;
    setPage(newPage);
  }

  function EditUser(id) {
    navigate(`/user/${id}`);
  }

  function ChangeStatusUser(id, name, status) {
    setShowModalDelete(true);
    setStatusUsers(status);
    setName(name);
    setUserId(id);
  }

  return (
    <div className="p-6">
      <div className="text-3xl font-bold text-gray-800 mb-6">
        Users Management
      </div>

      <NavBar
        item={[
          {
            icon: <BiSolidUserDetail style={{ fontSize: "22px" }} />,
            title: "All User",
            value: checkStatus,
            onClick: () => {
              setUserBlock("");
              setCheckStatus("All User");
              setPage(1);
            },
          },
          {
            icon: <MdOutlineVerifiedUser />,
            title: "Active Users",
            value: checkStatus,
            onClick: () => {
              setUserBlock(false);
              setCheckStatus("Active User");
              setPage(1);
            },
          },
          {
            icon: <MdOutlineBlock />,
            title: "Blocked Users",
            value: checkStatus,
            onClick: () => {
              setUserBlock(true);
              setCheckStatus("Block User");
              setPage(1);
            },
          },
          {
            icon: <IoIosAddCircleOutline />,
            title: "Add User",
            onClick: () => setShowAddModal(true),
          },
        ]}
        onSearch={handleSearch}
      />

      <div className="flex justify-center mt-8">
        <div className="w-full max-w-6xl md:overflow-x-auto">
          <table className="w-full bg-white shadow-md rounded-lg ">
            <thead className="bg-gradient-to-r text-left from-buttonColor-shade4 to-marginColor-shade9 text-white">
              <tr>
                <th className="px-4 py-2 text-md font-medium rounded-tl-lg">
                  User Name
                </th>
                <th className="px-4 py-2 text-md font-medium">Mobile Number</th>
                <th className="px-4 py-2 text-md font-medium">Status</th>
                <th className="px-4 py-2 text-md font-medium rounded-tr-lg">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {loading ? (
                <tr>
                  <td className="px-4 py-3 text-center" colSpan="4">
                    <Loading />
                  </td>
                </tr>
              ) : users.length > 0 ? (
                users.map((item) => (
                  <tr key={item._id}>
                    <td className="px-4 py-2 text-md font-medium rounded-tl-lg">
                      {item.userName || "-"}
                    </td>
                    <td className="px-4 py-2 text-md font-medium">
                      {item.mobile}
                    </td>
                    <td className={`px-4 py-4`}>
                      <span
                        className={`px-2 hover:cursor-pointer py-1 rounded-full text-xs font-medium 
                                            ${item.isDeleted ? "bg-red-100 text-red-700" : "bg-green-100 text-green-700"}`}
                        onClick={() =>
                          ChangeStatusUser(
                            item._id,
                            item.userName,
                            item.isDeleted,
                          )
                        }
                      >
                        {item.isDeleted ? "Deleted" : "Active"}
                      </span>
                    </td>
                    <td className="px-4 py-2 text-md font-medium rounded-tr-lg">
                      <button
                        className="text-blue-500 hover:text-blue-700 font-medium mr-4"
                        onClick={() => EditUser(item._id)}
                      >
                        Edit
                      </button>
                      {/*<button*/}
                      {/*    className="text-red-500 hover:text-red-700 font-medium"*/}
                      {/*>*/}
                      {/*    Delete*/}
                      {/*</button>*/}
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="">
                  <td className="px-4 py-3 text-center" colSpan="4">
                    User not found!
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {!loading && users.length > 0 && (
            <Pagination
              page={page}
              totalPages={totalPages}
              onPageChange={goToPage}
            />
          )}
        </div>
      </div>

      {showModalDelete && (
        <ModalChangeStatus
          setShow={setShowModalDelete}
          name={name}
          status={statusUsers}
          apiGetUser={apiGetUser}
          id={UserId}
        />
      )}

      {showAddModal && (
        <ModalAddUser setShow={setShowAddModal} apiGetUser={apiGetUser} />
      )}
    </div>
  );
}

export function ModalChangeStatus({ setShow, id, name, apiGetUser, status }) {
  const [loading, setLoading] = useState(false);

  function ChangeStatus() {
    setLoading(true);
    apiRequests
      .delete(
        status
          ? `/api/user/v1/unblock-user-admin`
          : `/api/user/v1/block-user-admin`,
        {
          data: {
            userId: id,
          },
        },
      )
      .then((res) => {
        toast.success(res.data.en_message);
        setShow(false);
        apiGetUser();
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }

  return (
    <div className="report-modal fixed inset-0 bg-black bg-opacity-60 transition-opacity">
      <div className="flex min-h-full items-end justify-center p-3 text-center">
        <div className="modal relative text-black transform overflow-hidden rounded-lg bg-white p-8 w-[30%] md:w-[95%] m-auto flex flex-col gap-5">
          <div className="text-gray-500">
            Do you want to change the status of
            <span className="text-firstColor-shade9 font-bold"> {name} </span>?
          </div>

          <div className="flex justify-center items-center gap-5 ">
            <button
              className={`px-4 py-1 border-2  ${status ? `hover:bg-firstColor-shade4 hover:text-white border-firstColor-shade4 text-firstColor-shade4` : `hover:bg-red-600 hover:text-white border-red-600 text-red-600`}  rounded-lg `}
              onClick={ChangeStatus}
            >
              {loading ? (
                <Loading textColor={status && `white-0`} />
              ) : status ? (
                "Unblock"
              ) : (
                "block"
              )}
            </button>

            <button
              className="hover:bg-gray-300 border-2 px-4 py-1 rounded-lg"
              onClick={() => setShow(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export function ModalAddUser({ setShow, apiGetUser }) {
  const [loadingCreate, setLoadingCreate] = useState(false);

  const [userName, setUserName] = useState("");
  const [name, setName] = useState("");
  const [city, setCity] = useState("");
  const [birthday, setBirthday] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [password, setPassword] = useState("");

  function CreateUser() {
    if (
      !userName ||
      !name ||
      !city ||
      !birthday ||
      !mobile ||
      !email ||
      !address ||
      !password
    ) {
      toast.error("Please fill out all required fields");
      return;
    }

    setLoadingCreate(true);

    const data = {
      userName: userName,
      name: name,
      city: city,
      birthday: birthday,
      mobile: mobile,
      email: email,
      address: address,
      password: password,
    };

    apiRequests
      .post(`/api/user/v1/register-user`, data)
      .then((res) => {
        toast.success(res.data.en_message);
        setShow(false);
        apiGetUser();
      })
      .catch(() => {})
      .finally(() => setLoadingCreate(false));
  }

  return (
    <div className="report-modal fixed inset-0 bg-black bg-opacity-60 md:overflow-y-auto transition-opacity">
      <div className="flex min-h-full items-end justify-center p-3 text-center">
        <div className="modal relative text-black transform overflow-hidden rounded-lg bg-white p-8 w-[60%] md:w-[90%] m-auto flex flex-col gap-5">
          <h2 className="text-2xl font-bold">Add new user</h2>

          <div className="grid grid-cols-2 md:flex md:flex-col auto-cols-auto gap-6 text-gray-500 justify-center">
            <div className="mt-4">
              <label className="block mb-2 text-left font-medium">
                User Name *
              </label>
              <input
                required
                placeholder="enter User Name"
                className="w-full p-2 border rounded-lg"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
              />
            </div>

            <div className="mt-4">
              <label className="block mb-2 text-left font-medium">Name *</label>
              <input
                required
                placeholder="enter Name"
                className="w-full p-2 border rounded-lg"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div className="mt-4">
              <label className="block mb-2 text-left font-medium">City *</label>
              <input
                required
                placeholder="enter City"
                className="w-full p-2 border rounded-lg"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />
            </div>

            <div className="mt-4">
              <label className="block mb-2 text-left font-medium">
                Birthday *
              </label>
              <input
                required
                type="date"
                className="w-full p-2 border rounded-lg"
                value={birthday}
                onChange={(e) => setBirthday(e.target.value)}
              />
            </div>

            <div className="mt-4">
              <label className="block mb-2 text-left font-medium">
                Phone Number *
              </label>
              <input
                required
                placeholder="enter Phone Number"
                className="w-full p-2 border rounded-lg"
                value={mobile}
                inputMode="numeric"
                onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
              />
            </div>

            <div className="mt-4">
              <label className="block mb-2 text-left font-medium">
                Email *
              </label>
              <input
                required
                placeholder="enter Email Address"
                className="w-full p-2 border rounded-lg"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="mt-4">
              <label className="block mb-2 text-left font-medium">
                Address *
              </label>
              <input
                required
                placeholder="enter Address"
                className="w-full p-2 border rounded-lg"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </div>

            <div className="mt-4">
              <label className="block mb-2 text-left font-medium">
                Password *
              </label>
              <input
                required
                placeholder="enter Password"
                className="w-full p-2 border rounded-lg"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <div className="flex justify-center items-center gap-5 mt-8">
            <button
              className={`px-6 py-1 border-2 border-firstColor-shade4 rounded-lg`}
              onClick={CreateUser}
            >
              {loadingCreate ? (
                <Loading textColor={`white-0`} />
              ) : (
                "Create User"
              )}
            </button>

            <button
              className="hover:bg-gray-300 border-2 px-4 py-1 rounded-lg"
              onClick={() => setShow(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
